import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { authMe, authLogin, authRegister, authLogout } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);       // null = unknown, false = anon, object = user
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const u = await authMe();
      setUser(u);
    } catch {
      setUser(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    const { user: u } = await authLogin({ email, password });
    setUser(u);
    return u;
  };
  const register = async (email, password, name, as_developer = false) => {
    const { user: u } = await authRegister({ email, password, name, as_developer });
    setUser(u);
    return u;
  };
  const logout = async () => {
    await authLogout();
    setUser(false);
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, register, logout, refresh, setUser }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
